import React from 'react';

import { ExclamationTriangleIcon } from '@heroicons/react/16/solid';
import CustomTooltip from './CustomTooltip';

export default function WarningWithTooltip({
  tooltipMessage,
  iconStyle,
}: {
  tooltipMessage: string;
  iconStyle?: string;
}) {
  // Default icon style
  const defaultIconStyle = iconStyle ?? 'w-3 h-3 mr-1 text-yellow-400';

  return (
    <CustomTooltip tooltip={tooltipMessage}>
      <ExclamationTriangleIcon className={defaultIconStyle} />
    </CustomTooltip>
  );
}
